import enUS from './en-US.json';
import esMX from './es-MX.json';

export default {
  'en-US': enUS,
  'es-MX': esMX,
};
